import clsx from "clsx"
import { AriaRole } from "react"
import { toTestId } from "./testid"

interface TabButtonProps {
	isActive: boolean
	onClick: () => void
	children: React.ReactNode
	trackingLabel?: string
	activeWeight?: "medium" | "bold"
	className?: string
	ariaLabel?: string
	ariaSelected?: boolean
	role?: AriaRole
	dataTestId?: string
}

export const TabButton = ({
	isActive,
	onClick,
	children,
	trackingLabel,
	activeWeight = "medium",
	className = "",
	ariaLabel,
	ariaSelected,
	role,
	dataTestId,
}: TabButtonProps) => {
	const activeWeightClass = activeWeight === "bold" ? "font-bold" : "font-medium"

	return (
		<button
			onClick={onClick}
			className={clsx(
				"text-sm transition-colors",
				isActive
					? [activeWeightClass, "text-base-50"]
					: "font-medium text-base-400 hover:text-base-50",
				className,
			)}
			style={{ lineHeight: "normal" }}
			data-tracking={trackingLabel}
			data-testid={dataTestId ?? (trackingLabel ? toTestId(trackingLabel) : undefined)}
			aria-label={ariaLabel}
			aria-selected={ariaSelected}
			role={role}
		>
			{children}
		</button>
	)
}
